import {RegistryEntry} from "./registryentry.mjs";

export class RegistryManager{
    constructor(){
        var _registryMap = new Map([]);

        Object.defineProperty(this,'registryMap',{
            get : ()=>_registryMap
        });
    }

    // ==========
    // private
    // ---------
    getRegistryMap(){ return this.registryMap; }

    // ==========
    // public 
    // ---------
    addCreateFn(name,createFn){
        var registryMap = this.getRegistryMap();
        var entry = new RegistryEntry(name, createFn);
        if (registryMap.has(name)){
            registryMap.get(name).setCreateFn(createFn)
        } else registryMap.set(name, entry);
    }

    addEventDefineListener(name,eventDefineListener){
        var registryMap = this.getRegistryMap();
        if (!registryMap.has(name)) { throw new Error('RegistryManager. This entry does not exist ');  }
        registryMap.get(name).addEventDefineListener(eventDefineListener)    
    }

    clearEventDefineListener(name){
        var registryMap = this.getRegistryMap();
        if (registryMap.has(name)) registryMap.get(name).clearEventDefineListener();          
    }

    getCreateFn(name){
        var registryMap = this.getRegistryMap();
        if (!registryMap.has(name)) { console.log('RegistryManager. This entry does not exist '); return }
        return registryMap.get(name).getCreateFn();
    }

    getEventDefineListeners(name){
        var registryMap = this.getRegistryMap();
        if (!registryMap.has(name)) { console.log('RegistryManager. This entry does not exist '); return; }
        return registryMap.get(name).getEventDefineListeners();
    }

    getComponent(name){
        var registryMap = this.getRegistryMap();
        if (!registryMap.has(name)) { console.log('RegistryManager. This entry does not exist '); return; }
        return registryMap.get(name).getComponent();       
    }

    setComponent(name,component){
        var registryMap = this.getRegistryMap();
        if (!registryMap.has(name)) { console.log('RegistryManager. This entry does not exist '); return; }
        registryMap.get(name).setComponent(component);
    }

}